// extracted by mini-css-extract-plugin
module.exports = {"navDesktop":"styles_navDesktop__1fBBj","nav":"styles_nav__bjKyX","stickyNav":"styles_stickyNav__aznfb","gridNavDesktop":"styles_gridNavDesktop__RneVn"};